import _extends from 'babel-runtime/helpers/extends';

import { units } from '@/utils/css';

export default {
  props: {
    src: {
      type: String,
      default: ''
    },

    previewSrc: {
      type: String,
      default: ''
    },

    type: {
      type: String,
      default: 'image'
    },

    trigger: {
      type: String,
      default: 'click'
    },

    placement: {
      type: String,
      default: 'right'
    },

    width: {
      type: [String, Number], // 如果是 number 就认为要使用单位 px，string 就不做处理
      default: 40
    },

    popoverWidth: {
      type: [String, Number],
      default: 300
    },

    imageStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    theme: {
      type: String,
      default: ''
    }
  },

  data: function data() {
    return {};
  },


  computed: {
    innerImageStyle: function innerImageStyle() {
      return _extends({}, this.imageStyle, {
        width: units.splice(this.width)
      });
    },
    innerPopoverWidth: function innerPopoverWidth() {
      return this.popoverWidth || '';
    }
  },

  methods: {}
};